import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=3d8be3f6&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8be3f6')) {
      api.createRecord('3d8be3f6', component.options)
    } else {
      api.reload('3d8be3f6', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=3d8be3f6&", function () {
      api.rerender('3d8be3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8tgay1QcTqvDF/JS/comp/stardisplay.vue"
export default component.exports